/** In-app route of a leave request on the company leave calendar. */
export function buildLeaveCalendarPath(
  companyId: string,
  leaveId: string
): string {
  return `/app/${encodeURIComponent(companyId)}/leave-calendar?leave=${encodeURIComponent(leaveId)}`;
}

/** The same place, addressed from outside the app (email, chat, clipboard). */
export function buildLeaveCalendarShareUrl(
  companyId: string,
  leaveId: string
): string {
  const origin =
    typeof window !== "undefined" ? window.location.origin : "";
  return `${origin}${buildLeaveCalendarPath(companyId, leaveId)}`;
}

export async function copyTextToClipboard(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "fixed";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(textarea);
    return ok;
  } catch {
    return false;
  }
}

export async function copyLeaveCalendarShareLink(
  companyId: string,
  leaveId: string
): Promise<boolean> {
  return copyTextToClipboard(buildLeaveCalendarShareUrl(companyId, leaveId));
}
